import SelectedMedicines from '@commons/medicineSearch/selectedItems'
import SearchMedicines from '@commons/medicineSearch/search'
import Column from '@components/column'
import { useEffect } from 'react'

const Medicine = ({ values, setFieldValue }) => {
  console.log(values)
  return (
    <Column rowGap={20}>
      <Column bg="white" styleColumn="padding:20px 15px;border-radius:8px;">
        <SearchMedicines
          selectedItems={values?.medicines}
          setFieldValue={setFieldValue}
        />
      </Column>
      <Column bg="white" styleColumn="padding:20px 15px;border-radius:8px;">
        <SelectedMedicines
          selectedItems={values?.medicines}
          setFieldValue={setFieldValue}
        />
      </Column>
    </Column>
  )
}

export default Medicine
